var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "section-head" }, [_vm._v("转盘奖池设置")]),
      _c(
        "el-table",
        {
          staticClass: "tier-table",
          attrs: { data: _vm.tiers, border: "", size: "mini" },
        },
        [
          _c("el-table-column", {
            attrs: { label: "格子", width: "56", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.$index + 1))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖励", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "tier-reward-cell" },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100px" },
                            attrs: {
                              placeholder: "选择奖励类型",
                              size: "mini",
                            },
                            on: {
                              change: function ($event) {
                                return _setup.onTierTypeChange(scope.$index)
                              },
                            },
                            model: {
                              value: scope.row.bonus_type,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "bonus_type", $$v)
                              },
                              expression: "scope.row.bonus_type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: "无奖励",
                                value: _setup.BONUS_NONE,
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: "金币",
                                value: _setup.BONUS_GOLD,
                              },
                            }),
                          ],
                          1
                        ),
                        scope.row.bonus_type === _setup.BONUS_GOLD
                          ? [
                              _c("span", { staticClass: "currency-prefix" }),
                              _c("el-input-number", {
                                staticClass: "tier-gold-input",
                                staticStyle: { width: "80px" },
                                attrs: {
                                  min: 0,
                                  precision: 2,
                                  controls: false,
                                  size: "mini",
                                },
                                model: {
                                  value: scope.row.reward_count_yuan,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "reward_count_yuan",
                                      $$v
                                    )
                                  },
                                  expression: "scope.row.reward_count_yuan",
                                },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "库存", width: "170" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "tier-stock-line" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { size: "mini" },
                            model: {
                              value: scope.row.total_unlimited,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "total_unlimited", $$v)
                              },
                              expression: "scope.row.total_unlimited",
                            },
                          },
                          [_vm._v("不限")]
                        ),
                        _c("el-input-number", {
                          staticClass: "tier-stock-input",
                          attrs: {
                            disabled: scope.row.total_unlimited,
                            min: 0,
                            precision: 0,
                            controls: false,
                            size: "mini",
                          },
                          model: {
                            value: scope.row.available_num,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "available_num", $$v)
                            },
                            expression: "scope.row.available_num",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "已发放", width: "72", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.row.settled_count))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "稽核倍数", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        min: 0,
                        precision: 2,
                        controls: false,
                        size: "mini",
                        disabled: scope.row.bonus_type !== _setup.BONUS_GOLD,
                      },
                      model: {
                        value: scope.row.multiple,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "multiple", $$v)
                        },
                        expression: "scope.row.multiple",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "概率权重", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        min: 0,
                        precision: 0,
                        controls: false,
                        size: "mini",
                        disabled: _setup.isTierOutOfStock(scope.row),
                      },
                      model: {
                        value: scope.row.weight,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "weight", $$v)
                        },
                        expression: "scope.row.weight",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "综合概率", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_setup.tierProbTexts[scope.$index]))]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }